import { createContext } from "react";

const OnboardingContext = createContext();

export default OnboardingContext;
